import { COLORS } from '../../../utils/colors'

export const useStyles = () => {
  return {
    confirmButton: { fontSize: '13px', textTransform: 'none' },
    cancelButton: {
      color: COLORS.PRIMARY,
      fontWeight: 500,
      textTransform: 'none',
    },
    container: {
      width: '600px',
      minHeight: '400px',
      //[theme.breakpoints.down('xs')]: {
      //  width: 'calc(100vw - 32px)',
      //},
      '& .inputSelect': {
        width: 'calc(100% - 35px)',
      },
    },
    button: {
      float: 'right',
    },
    paper: {
      //[theme.breakpoints.down('xs')]: {
      //  margin: '16px',
      //},
    },
    headline: {
      marginBottom: '1.3em',
      fontSize: '1.1rem',
    },
    listSection: {
      margin: '2em 0 0.8em',
      '&:first-child': {
        margin: '1em 0 2em 0',
      },
    },
    noiseCancellationContainer: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    krispContainer: {
      display: 'flex',
      alignItems: 'center',
      '& svg': {
        '&:not(:last-child)': {
          margin: '0 0.3em',
        },
      },
    },
    krispInfoText: {
      margin: '0 0 1.5em 0.5em',
    },
    preview: {
      width: '300px',
      maxHeight: '200px',
      margin: '0.5em auto',
      '& video': {
        maxHeight: '200px',
      },
    },
    videoTrack: {
      height: '100%',
      width: '100%',
      objectFit: 'cover',
      transition: 'all .2s',
      zIndex: 10,
    },
  }
}
